/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as InquiriesRouteImport } from './routes/inquiries'
import { Route as ClientsIndexRouteImport } from './routes/clients.index'
import { Route as ClientsExistingRouteImport } from './routes/clients.existing'
import { Route as FirmIndexRouteImport } from './routes/firm.index'
import { Route as FirmAreaRouteImport } from './routes/firm.$area'
import { Route as HelpIndexRouteImport } from './routes/help.index'
import { Route as HelpSlugRouteImport } from './routes/help.$slug'
import { Route as IntakesIndexRouteImport } from './routes/intakes.index'
import { Route as IntakesCaseIdRouteImport } from './routes/intakes.$caseId'
import { Route as ObligationsIndexRouteImport } from './routes/obligations.index'
import { Route as ObligationsDocumentsRouteImport } from './routes/obligations.documents'
import { Route as ObligationsPeopleRouteImport } from './routes/obligations.people'
import { Route as ObligationsProvidersRouteImport } from './routes/obligations.providers'
import { Route as ObligationsTrainingsRouteImport } from './routes/obligations.trainings'
import { Route as PartnerConnectRouteImport } from './routes/partner.connect'
import { Route as ProfileIndexRouteImport } from './routes/profile.index'
import { Route as ProfileSplatRouteImport } from './routes/profile.$'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsAreaRouteImport } from './routes/settings.$area'
import { Route as ClientsCaseIdIndexRouteImport } from './routes/clients.$caseId.index'
import { Route as ClientsCaseIdEngagementRouteImport } from './routes/clients.$caseId.engagement'
import { Route as ClientsCaseIdMandatesMandateEngagementRouteImport } from './routes/clients.$caseId.mandates.$mandate.engagement'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const InquiriesRoute = InquiriesRouteImport.update({
  id: '/inquiries',
  path: '/inquiries',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsExistingRoute = ClientsExistingRouteImport.update({
  id: '/clients/existing',
  path: '/clients/existing',
  getParentRoute: () => rootRouteImport,
} as any)
const FirmIndexRoute = FirmIndexRouteImport.update({
  id: '/firm/',
  path: '/firm/',
  getParentRoute: () => rootRouteImport,
} as any)
const FirmAreaRoute = FirmAreaRouteImport.update({
  id: '/firm/$area',
  path: '/firm/$area',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpIndexRoute = HelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpSlugRoute = HelpSlugRouteImport.update({
  id: '/help/$slug',
  path: '/help/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const IntakesIndexRoute = IntakesIndexRouteImport.update({
  id: '/intakes/',
  path: '/intakes/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntakesCaseIdRoute = IntakesCaseIdRouteImport.update({
  id: '/intakes/$caseId',
  path: '/intakes/$caseId',
  getParentRoute: () => rootRouteImport,
} as any)
const ObligationsIndexRoute = ObligationsIndexRouteImport.update({
  id: '/obligations/',
  path: '/obligations/',
  getParentRoute: () => rootRouteImport,
} as any)
const ObligationsDocumentsRoute = ObligationsDocumentsRouteImport.update({
  id: '/obligations/documents',
  path: '/obligations/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const ObligationsPeopleRoute = ObligationsPeopleRouteImport.update({
  id: '/obligations/people',
  path: '/obligations/people',
  getParentRoute: () => rootRouteImport,
} as any)
const ObligationsProvidersRoute = ObligationsProvidersRouteImport.update({
  id: '/obligations/providers',
  path: '/obligations/providers',
  getParentRoute: () => rootRouteImport,
} as any)
const ObligationsTrainingsRoute = ObligationsTrainingsRouteImport.update({
  id: '/obligations/trainings',
  path: '/obligations/trainings',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerConnectRoute = PartnerConnectRouteImport.update({
  id: '/partner/connect',
  path: '/partner/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileSplatRoute = ProfileSplatRouteImport.update({
  id: '/profile/$',
  path: '/profile/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAreaRoute = SettingsAreaRouteImport.update({
  id: '/settings/$area',
  path: '/settings/$area',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsCaseIdIndexRoute = ClientsCaseIdIndexRouteImport.update({
  id: '/clients/$caseId/',
  path: '/clients/$caseId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsCaseIdEngagementRoute = ClientsCaseIdEngagementRouteImport.update({
  id: '/clients/$caseId/engagement',
  path: '/clients/$caseId/engagement',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsCaseIdMandatesMandateEngagementRoute =
  ClientsCaseIdMandatesMandateEngagementRouteImport.update({
    id: '/clients/$caseId/mandates/$mandate/engagement',
    path: '/clients/$caseId/mandates/$mandate/engagement',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/inquiries': typeof InquiriesRoute
  '/clients/existing': typeof ClientsExistingRoute
  '/firm/$area': typeof FirmAreaRoute
  '/help/$slug': typeof HelpSlugRoute
  '/intakes/$caseId': typeof IntakesCaseIdRoute
  '/obligations/documents': typeof ObligationsDocumentsRoute
  '/obligations/people': typeof ObligationsPeopleRoute
  '/obligations/providers': typeof ObligationsProvidersRoute
  '/obligations/trainings': typeof ObligationsTrainingsRoute
  '/partner/connect': typeof PartnerConnectRoute
  '/profile/$': typeof ProfileSplatRoute
  '/settings/$area': typeof SettingsAreaRoute
  '/clients/': typeof ClientsIndexRoute
  '/firm/': typeof FirmIndexRoute
  '/help/': typeof HelpIndexRoute
  '/intakes/': typeof IntakesIndexRoute
  '/obligations/': typeof ObligationsIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/clients/$caseId/engagement': typeof ClientsCaseIdEngagementRoute
  '/clients/$caseId/': typeof ClientsCaseIdIndexRoute
  '/clients/$caseId/mandates/$mandate/engagement': typeof ClientsCaseIdMandatesMandateEngagementRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/inquiries': typeof InquiriesRoute
  '/clients/existing': typeof ClientsExistingRoute
  '/firm/$area': typeof FirmAreaRoute
  '/help/$slug': typeof HelpSlugRoute
  '/intakes/$caseId': typeof IntakesCaseIdRoute
  '/obligations/documents': typeof ObligationsDocumentsRoute
  '/obligations/people': typeof ObligationsPeopleRoute
  '/obligations/providers': typeof ObligationsProvidersRoute
  '/obligations/trainings': typeof ObligationsTrainingsRoute
  '/partner/connect': typeof PartnerConnectRoute
  '/profile/$': typeof ProfileSplatRoute
  '/settings/$area': typeof SettingsAreaRoute
  '/clients': typeof ClientsIndexRoute
  '/firm': typeof FirmIndexRoute
  '/help': typeof HelpIndexRoute
  '/intakes': typeof IntakesIndexRoute
  '/obligations': typeof ObligationsIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/clients/$caseId/engagement': typeof ClientsCaseIdEngagementRoute
  '/clients/$caseId': typeof ClientsCaseIdIndexRoute
  '/clients/$caseId/mandates/$mandate/engagement': typeof ClientsCaseIdMandatesMandateEngagementRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/inquiries': typeof InquiriesRoute
  '/clients/existing': typeof ClientsExistingRoute
  '/firm/$area': typeof FirmAreaRoute
  '/help/$slug': typeof HelpSlugRoute
  '/intakes/$caseId': typeof IntakesCaseIdRoute
  '/obligations/documents': typeof ObligationsDocumentsRoute
  '/obligations/people': typeof ObligationsPeopleRoute
  '/obligations/providers': typeof ObligationsProvidersRoute
  '/obligations/trainings': typeof ObligationsTrainingsRoute
  '/partner/connect': typeof PartnerConnectRoute
  '/profile/$': typeof ProfileSplatRoute
  '/settings/$area': typeof SettingsAreaRoute
  '/clients/': typeof ClientsIndexRoute
  '/firm/': typeof FirmIndexRoute
  '/help/': typeof HelpIndexRoute
  '/intakes/': typeof IntakesIndexRoute
  '/obligations/': typeof ObligationsIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/clients/$caseId/engagement': typeof ClientsCaseIdEngagementRoute
  '/clients/$caseId/': typeof ClientsCaseIdIndexRoute
  '/clients/$caseId/mandates/$mandate/engagement': typeof ClientsCaseIdMandatesMandateEngagementRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/inbox'
    | '/inquiries'
    | '/clients/existing'
    | '/firm/$area'
    | '/help/$slug'
    | '/intakes/$caseId'
    | '/obligations/documents'
    | '/obligations/people'
    | '/obligations/providers'
    | '/obligations/trainings'
    | '/partner/connect'
    | '/profile/$'
    | '/settings/$area'
    | '/clients/'
    | '/firm/'
    | '/help/'
    | '/intakes/'
    | '/obligations/'
    | '/profile/'
    | '/settings/'
    | '/clients/$caseId/engagement'
    | '/clients/$caseId/'
    | '/clients/$caseId/mandates/$mandate/engagement'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/inbox'
    | '/inquiries'
    | '/clients/existing'
    | '/firm/$area'
    | '/help/$slug'
    | '/intakes/$caseId'
    | '/obligations/documents'
    | '/obligations/people'
    | '/obligations/providers'
    | '/obligations/trainings'
    | '/partner/connect'
    | '/profile/$'
    | '/settings/$area'
    | '/clients'
    | '/firm'
    | '/help'
    | '/intakes'
    | '/obligations'
    | '/profile'
    | '/settings'
    | '/clients/$caseId/engagement'
    | '/clients/$caseId'
    | '/clients/$caseId/mandates/$mandate/engagement'
  id:
    | '__root__'
    | '/'
    | '/inbox'
    | '/inquiries'
    | '/clients/existing'
    | '/firm/$area'
    | '/help/$slug'
    | '/intakes/$caseId'
    | '/obligations/documents'
    | '/obligations/people'
    | '/obligations/providers'
    | '/obligations/trainings'
    | '/partner/connect'
    | '/profile/$'
    | '/settings/$area'
    | '/clients/'
    | '/firm/'
    | '/help/'
    | '/intakes/'
    | '/obligations/'
    | '/profile/'
    | '/settings/'
    | '/clients/$caseId/engagement'
    | '/clients/$caseId/'
    | '/clients/$caseId/mandates/$mandate/engagement'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InboxRoute: typeof InboxRoute
  InquiriesRoute: typeof InquiriesRoute
  ClientsExistingRoute: typeof ClientsExistingRoute
  FirmAreaRoute: typeof FirmAreaRoute
  HelpSlugRoute: typeof HelpSlugRoute
  IntakesCaseIdRoute: typeof IntakesCaseIdRoute
  ObligationsDocumentsRoute: typeof ObligationsDocumentsRoute
  ObligationsPeopleRoute: typeof ObligationsPeopleRoute
  ObligationsProvidersRoute: typeof ObligationsProvidersRoute
  ObligationsTrainingsRoute: typeof ObligationsTrainingsRoute
  PartnerConnectRoute: typeof PartnerConnectRoute
  ProfileSplatRoute: typeof ProfileSplatRoute
  SettingsAreaRoute: typeof SettingsAreaRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  FirmIndexRoute: typeof FirmIndexRoute
  HelpIndexRoute: typeof HelpIndexRoute
  IntakesIndexRoute: typeof IntakesIndexRoute
  ObligationsIndexRoute: typeof ObligationsIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  ClientsCaseIdEngagementRoute: typeof ClientsCaseIdEngagementRoute
  ClientsCaseIdIndexRoute: typeof ClientsCaseIdIndexRoute
  ClientsCaseIdMandatesMandateEngagementRoute: typeof ClientsCaseIdMandatesMandateEngagementRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inquiries': {
      id: '/inquiries'
      path: '/inquiries'
      fullPath: '/inquiries'
      preLoaderRoute: typeof InquiriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/existing': {
      id: '/clients/existing'
      path: '/clients/existing'
      fullPath: '/clients/existing'
      preLoaderRoute: typeof ClientsExistingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/firm/': {
      id: '/firm/'
      path: '/firm'
      fullPath: '/firm/'
      preLoaderRoute: typeof FirmIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/firm/$area': {
      id: '/firm/$area'
      path: '/firm/$area'
      fullPath: '/firm/$area'
      preLoaderRoute: typeof FirmAreaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/': {
      id: '/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof HelpIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/$slug': {
      id: '/help/$slug'
      path: '/help/$slug'
      fullPath: '/help/$slug'
      preLoaderRoute: typeof HelpSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intakes/': {
      id: '/intakes/'
      path: '/intakes'
      fullPath: '/intakes/'
      preLoaderRoute: typeof IntakesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intakes/$caseId': {
      id: '/intakes/$caseId'
      path: '/intakes/$caseId'
      fullPath: '/intakes/$caseId'
      preLoaderRoute: typeof IntakesCaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/obligations/': {
      id: '/obligations/'
      path: '/obligations'
      fullPath: '/obligations/'
      preLoaderRoute: typeof ObligationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/obligations/documents': {
      id: '/obligations/documents'
      path: '/obligations/documents'
      fullPath: '/obligations/documents'
      preLoaderRoute: typeof ObligationsDocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/obligations/people': {
      id: '/obligations/people'
      path: '/obligations/people'
      fullPath: '/obligations/people'
      preLoaderRoute: typeof ObligationsPeopleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/obligations/providers': {
      id: '/obligations/providers'
      path: '/obligations/providers'
      fullPath: '/obligations/providers'
      preLoaderRoute: typeof ObligationsProvidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/obligations/trainings': {
      id: '/obligations/trainings'
      path: '/obligations/trainings'
      fullPath: '/obligations/trainings'
      preLoaderRoute: typeof ObligationsTrainingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner/connect': {
      id: '/partner/connect'
      path: '/partner/connect'
      fullPath: '/partner/connect'
      preLoaderRoute: typeof PartnerConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/$': {
      id: '/profile/$'
      path: '/profile/$'
      fullPath: '/profile/$'
      preLoaderRoute: typeof ProfileSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/$area': {
      id: '/settings/$area'
      path: '/settings/$area'
      fullPath: '/settings/$area'
      preLoaderRoute: typeof SettingsAreaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$caseId/': {
      id: '/clients/$caseId/'
      path: '/clients/$caseId'
      fullPath: '/clients/$caseId/'
      preLoaderRoute: typeof ClientsCaseIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$caseId/engagement': {
      id: '/clients/$caseId/engagement'
      path: '/clients/$caseId/engagement'
      fullPath: '/clients/$caseId/engagement'
      preLoaderRoute: typeof ClientsCaseIdEngagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$caseId/mandates/$mandate/engagement': {
      id: '/clients/$caseId/mandates/$mandate/engagement'
      path: '/clients/$caseId/mandates/$mandate/engagement'
      fullPath: '/clients/$caseId/mandates/$mandate/engagement'
      preLoaderRoute: typeof ClientsCaseIdMandatesMandateEngagementRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InboxRoute: InboxRoute,
  InquiriesRoute: InquiriesRoute,
  ClientsExistingRoute: ClientsExistingRoute,
  FirmAreaRoute: FirmAreaRoute,
  HelpSlugRoute: HelpSlugRoute,
  IntakesCaseIdRoute: IntakesCaseIdRoute,
  ObligationsDocumentsRoute: ObligationsDocumentsRoute,
  ObligationsPeopleRoute: ObligationsPeopleRoute,
  ObligationsProvidersRoute: ObligationsProvidersRoute,
  ObligationsTrainingsRoute: ObligationsTrainingsRoute,
  PartnerConnectRoute: PartnerConnectRoute,
  ProfileSplatRoute: ProfileSplatRoute,
  SettingsAreaRoute: SettingsAreaRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  FirmIndexRoute: FirmIndexRoute,
  HelpIndexRoute: HelpIndexRoute,
  IntakesIndexRoute: IntakesIndexRoute,
  ObligationsIndexRoute: ObligationsIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  ClientsCaseIdEngagementRoute: ClientsCaseIdEngagementRoute,
  ClientsCaseIdIndexRoute: ClientsCaseIdIndexRoute,
  ClientsCaseIdMandatesMandateEngagementRoute:
    ClientsCaseIdMandatesMandateEngagementRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
